// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"ImageLoading_loadingWrapper__rGcdl","lottieLoader":"ImageLoading_lottieLoader__7C23x","loadingText":"ImageLoading_loadingText__FxX+p"};